<template>
  <div class="monitoring">
    <MonitoringBoth :patient-id="authUser.id"></MonitoringBoth>
  </div>
</template>
<script>
import MonitoringBoth from '@/components/Logs/Both'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    MonitoringBoth
  },
  metaInfo: {
    title: 'Monitoring'
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user'
    })
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/', text: this.$t('monitoring') })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setNavVisible: 'app/setNavVisible',
      setHead: 'head/set',
      resetHead: 'head/reset'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "monitoring": "მონიტორინგი"
  },
  "en": {
    "monitoring": "Monitoring"
  }
}
</i18n>
